import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

import '../../css/fonts.css'
import '../../css/base.css'
import '../../css/header.css'
import '../../css/search.css'
import '../../css/explorer.css'
import '../../css/bill.css'
import '../../css/lifecycle.css'
import '../../css/vote-detail.css'
import '../../css/pages.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
